const IMAGE_EXTENSIONS = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'])

export function isImageFileName(name) {
  const ext = String(name || '').split('.').pop()?.toLowerCase()
  return IMAGE_EXTENSIONS.has(ext)
}

export function buildPasteImageFilename(mime = 'image/png') {
  const ext = mime.includes('jpeg') || mime.includes('jpg') ? 'jpg' : mime.split('/')[1] || 'png'
  const safeExt = ext.replace(/[^a-z0-9]/gi, '') || 'png'
  const id = (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID().slice(0, 8)
    : String(Date.now())
  return `chat-image-${id}.${safeExt}`
}

export function chatFileDownloadUrl(msg) {
  if (!msg || msg.legacyFile) return null
  if (msg.id) return `/api/chat/messages/${msg.id}/file`
  const fileId = msg.fileId
  return fileId ? `/api/files/download/${fileId}` : null
}
